import React from "react";
import { Button, Icon, Paragraph, Title } from "@sicredi/react";
import styles from "./styles.module.scss";
import { Category } from "#/api/partnersShowcase/partnersShowcase";
import { PAGE } from "#/constants";
import { useRouter } from "#/hocs/withRouter";
import { handlerDatalayer } from "#/utils/handlerdatalayer";
import { useHistory } from "react-router-dom";

declare global {
  interface Window {
    dataLayer: [Record<string, number | string>];
  }
}

type Props = {
  categorie?: Category | undefined;
  setIsOpen: (value: boolean) => void;
  isOpen?: boolean;
};

export function MenuCategories({ categorie, setIsOpen }: Props) {
  const { handleGoNextPage } = useRouter();
  function handlerNextPage(): void {
    setIsOpen(false);

    handlerDatalayer({
      dataLayer: {
        event: "sicredi_parceiros",
        nome_do_evento: "menu",
        acao: categorie?.name,
      },
    });

    handleGoNextPage(PAGE.PARTNERS_SHOWCASE(), `?category=${categorie?.id}`);
  }
  return (
    <div data-testid={`options-categories${categorie?.id}`}>
      <Button
        data-testid={`menu-button${categorie?.id}`}
        className={styles["menu-button"]}
        onClick={() => handlerNextPage()}
      >
        <Paragraph
          style={{
            color: "#3fa110",
          }}
          // weight={}
        >
          {categorie?.name}
        </Paragraph>
        <Icon name="chevron-right" />
      </Button>
    </div>
  );
}

export function FixedNavigation({ setIsOpen }: Props) {
  const history = useHistory();
  function handleNavigate(route: string): void {
    history.push(route);
  }
  function handlerNextPage(item: {
    id: number;
    label: string;
    routerOrhref: string;
    route: boolean;
  }): void {
    if (item.route === true) {
      setIsOpen(false);
      handleNavigate(item.routerOrhref);
    } else {
      window.open(item.routerOrhref);
    }
  }

  const items = [
    {
      id: 0,
      label: "Início",
      routerOrhref: PAGE.ROOT(),
      route: true,
    },
    {
      id: 1,
      label: "Vitrine de Parceiros",
      routerOrhref: PAGE.PARTNERS_SHOWCASE(),
      route: true,
    },
    {
      id: 2,
      label: "Recargas e Gift Card",
      routerOrhref: PAGE.RECHARGES(),
      route: true,
    },
    {
      id: 3,
      label: "Nossas Parcerias e Descontos",
      routerOrhref: PAGE.BENEFITS_PARTNER(),
      route: true,
    },
  ];

  return (
    <div className={styles["other-links"]}>
      <Title as="h5">Acesso rápido</Title>
      {items.map((item) => (
        <Button
          data-testid={`other-links${item.id}`}
          key={item.id}
          className={styles["menu-button"]}
          onClick={() => handlerNextPage(item)}
        >
          <Paragraph
            style={{
              color: "#3fa110",
            }}
          >
            {item.label}
          </Paragraph>
          <Icon name="chevron-right" />
        </Button>
      ))}
    </div>
  );
}

export function FixedCategories() {
  const { handleGoNextPage } = useRouter();

  function handlerNextPage(item: {
    id: number;
    label: string;
    routerOrhref: string;
    route: boolean;
  }): void {
    handlerDatalayer({
      dataLayer: {
        event: "sicredi_parceiros",
        nome_do_evento: "menu",
        acao: item.label,
      },
    });
    window.open(item.routerOrhref);
  }

  const items = [
    {
      id: 1,
      label: "Shopping",
      routerOrhref: "https://shopping.sicredi.com.br/",
      route: false,
    },
    {
      id: 2,
      label: "Crédito",
      routerOrhref: "https://www.sicredi.com.br/site/credito/para-voce/",
      route: false,
    },
    {
      id: 3,
      label: "Consórcio Sicredi",
      routerOrhref: "https://www.sicredi.com.br/site/consorcios/",
      route: false,
    },
    {
      id: 4,
      label: "Seja um associado Sicredi",
      routerOrhref:
        "https://www.sicredi.com.br/site/seja-associado/?utm_source=SPD_sejassociado_menu_site&utm_medium=SPD_sejassociado_menu_site_associacoes&utm_campaign=SPD_sejassociado_menu&utm_id=SPD_sejassociado_menu&utm_term=SPD_sejassociado_menu2112",
      route: false,
    },
  ];

  return (
    <div className={styles["other-links"]}>
      {/* <Title as="h5">Conheça também</Title> */}
      {items.map((item) => (
        <Button
          data-testid={`other-links${item.id}`}
          key={item.id}
          className={styles["menu-button"]}
          onClick={() => handlerNextPage(item)}
        >
          <Paragraph
            style={{
              color: "#3fa110",
            }}
          >
            {item.label}
          </Paragraph>
          <Icon name="chevron-right" />
        </Button>
      ))}

      <div className={styles["divider"]} />

      <div className={styles["button-box"]}>
        <Button
          data-testid="button-orders"
          style={{
            display: "flex",
            flexDirection: "column",
            background: "#FAFAFA",
            margin: "20px",
            padding: "0.5rem",
          }}
          onClick={() => handleGoNextPage(PAGE.MY_ORDERS())}
        >
          <img src="/icons/package.svg" alt="meus-pedidos" /> <span>Meus </span>{" "}
          <span>Pedidos </span>{" "}
        </Button>
      </div>
    </div>
  );
}
